import { render, staticRenderFns } from "./ContactGroupForm.vue?vue&type=template&id=0e2662be&scoped=true&"
import script from "./ContactGroupForm.vue?vue&type=script&lang=js&"
export * from "./ContactGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactGroupForm.vue?vue&type=style&index=0&id=0e2662be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2662be",
  null
  
)

export default component.exports